<div class="container-fluid admin-form-page">
  <div class="row section1 justify-content-between align-items-center">
    <div class="col-12 col-md-auto">
      <div class="home-details">
        <h5 class="home-title">Create New Quote</h5>
        <p class="home-subtitle">Add new fun-words & quotes</p>
      </div>
    </div>
    <div class="col-12 col-md-auto">
      <div class="dashboard-btn dashboard-manage admin-page-actions mr-3">
        <div><a routerLink="/quotes">
          <button type="button" class="btn btn-primary btn-dashboard">Back</button>
        </a>
      </div>
    </div>
  </div>
</div>
<div class="section1">
  <div class="applicants-details details1 admin-form-card p-0">
    <div class="admin-form">
      <hr>
        <div class="col-12 job-form">
          <form class="admin-form" (ngSubmit)="addQuote()">
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label for="quoteType">Type*</label>
                  <select name="quoteType" id="quoteType"
                    (change)="this.keyword=''; this.quote.person_id = null;"
                    [(ngModel)]="quote.type" class="form-control">
                    <option value="Entity">Entity</option>
                    <option value="Bhakt">Bhakt</option>
                  </select>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label for="quoteEntity">Choose {{quote.type}}*</label>
                  @if (quote.type == 'Entity') {
                    <ng-select class="custom"
                      [(ngModel)]="quote.person_id"
                      name="quoteEntity"
                      id="quoteEntity"
                      [placeholder]="'Search and Select Entity'"
                      (input)="handleInputChange($event, 'entity')"
                      [clearable]="false">
                      @for (entity of lookupEntities; track entity) {
                        <ng-option
                        [value]="entity.id">{{entity.firstName}} {{entity.lastName}}</ng-option>
                      }
                    </ng-select>
                  }
                  @if (quote.type == 'Bhakt') {
                    <ng-select class="custom"
                      [(ngModel)]="quote.person_id"
                      name="quoteBhakt"
                      id="quoteBhakt"
                      [placeholder]="'Select User'"
                      (input)="handleInputChange($event, 'bhakt')"
                      [clearable]="false">
                      @for (user of lookupUsers; track user) {
                        <ng-option
                        [value]="user.id">{{user.firstName}} {{user.lastName}}</ng-option>
                      }
                    </ng-select>
                  }
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label for="quoteName">Famous quote*</label>
                  <textarea type="text" id="quoteName"
                    class="form-control"
                    placeholder="Enter famous quotes"
                    required name="quote"
                    [rows]="4"
                  [(ngModel)]="quote.famous_quote"></textarea>
                </div>
              </div>
            </div>
            <div class="row justify-content-end">
              <div class="col-auto ml-0 pl-0 mt-3">
                <button  class="btn btn-primary btn-dashboard py-0 ml-0" type="submit">Save Quotes</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
